import { render, staticRenderFns } from "./column.vue?vue&type=template&id=ba3288ec&scoped=true&"
import script from "./column.vue?vue&type=script&lang=js&"
export * from "./column.vue?vue&type=script&lang=js&"
import style0 from "./column.vue?vue&type=style&index=0&id=ba3288ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3288ec",
  null
  
)

export default component.exports